export enum ProductType {
  ELECTRICITY = 'ELECTRICITY',

  GAS = 'GAS',
}
